import { Button, Card, Form, InputGroup, Modal ,Badge, Dropdown } from 'react-bootstrap';
import { Link, } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { getKiinteistotWithRakennukset, createEmptyTaloyhtio, getKiinteistoImagesByKiinteistoId, getKohoAllOffers } from '../api/api';
import { useEffect, useState, useRef } from 'react';
import { BsBuildingFill } from 'react-icons/bs';
import { fetchCoverImageWithCache } from '../components/utils/fetchCoverImageWithCache';
import { getRecentVisits } from '../components/utils/recentlyVisited';

function RecentCard({ visit }) {
  const [imgUrl, setImgUrl] = useState(null);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    fetchCoverImageWithCache(visit.id_kiinteisto).then(url => url && setImgUrl(url));
  }, [visit.id_kiinteisto]);

  return (
    <div className="col-6 col-sm-4 col-md-3 col-lg-2">
      <Link to={`/taloyhtiokortti/${visit.id_kiinteisto}`} style={{ textDecoration: 'none' }}>
        <Card
          className="border-0 rounded-3 h-100"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{
            boxShadow: hovered ? '0 8px 24px rgba(0,0,0,0.25)' : '0 4px 12px rgba(0,0,0,0.15)',
            transform: hovered ? 'translateY(-3px)' : 'none',
            transition: 'box-shadow 0.18s ease, transform 0.18s ease',
          }}
        >
          <div
            className="rounded-top"
            style={{
              height: 90,
              position: 'relative',
              backgroundColor: imgUrl ? 'transparent' : '#04aa00',
              backgroundImage: imgUrl ? `url(${imgUrl})` : 'none',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {imgUrl && (
              <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.35)', borderRadius: '0.375rem 0.375rem 0 0' }} />
            )}
            {!imgUrl && <BsBuildingFill size={32} color="white" style={{ zIndex: 1 }} />}
            {visit.osoite && (
              <div style={{ position: 'relative', zIndex: 2, color: 'white', fontSize: '0.7rem', fontWeight: 600, textAlign: 'center', padding: '0 6px', textShadow: '0 1px 3px rgba(0,0,0,0.7)' }}>
                {visit.osoite}
              </div>
            )}
          </div>
          <Card.Body className="p-2 text-center">
            {visit.kohteen_nimi && (
              <div style={{ fontSize: '0.72rem', fontWeight: 600, color: '#212529', lineHeight: 1.3, marginBottom: 2 }}>
                {visit.kohteen_nimi}
              </div>
            )}
            <div style={{ fontSize: '0.68rem', color: '#6c757d', lineHeight: 1.3 }}>
              {visit.toimipaikka || visit.postinumero || visit.kiinteistotunnus}
            </div>
          </Card.Body>
        </Card>
      </Link>
    </div>
  );
}

function Taloyhtiokortit() {
  const [kiinteistot, setKiinteistot] = useState([]);
  const [recentVisits, setRecentVisits] = useState([]);
  const [resultOrder, setResultOrder] = useState('DESC');
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(12);
  const [totalItems, setTotalItems] = useState(0);
  const [errMessage, setErrMessage] = useState('');
  const [loading, setLoading] = useState(false);
const [showModal, setShowModal] = useState(false);
const [kohoOffers, setKohoOffers] = useState([]);
const [kohoLoading, setKohoLoading] = useState(false);
const [kohoError, setKohoError] = useState('');
const [kohoSelected, setKohoSelected] = useState(new Set());
const [kohoImporting, setKohoImporting] = useState(false);
const [kohoImportResults, setKohoImportResults] = useState(null);

const navigate = useNavigate();
  const increasePage = () => page < totalPages && setPage(page + 1);
  const decreasePage = () => page > 1 && setPage(page - 1);


  const fetchData = async () => {
    setLoading(true);
    setErrMessage('');
    try {
      const response = await getKiinteistotWithRakennukset(page, pageSize, 'id_kiinteisto', resultOrder, searchTerm);
      const { data, totalPages, totalItems } = response.data;

      // Set the list immediately WITHOUT images
      setKiinteistot(data.map(kiinteisto => ({ ...kiinteisto, coverImageUrl: null })));
      setTotalPages(totalPages);
      setTotalItems(totalItems);

      // Then fetch images asynchronously per item
      data.forEach(async (kiinteisto) => {
        const coverImageUrl = await fetchCoverImageWithCache(kiinteisto.id_kiinteisto);
        if (coverImageUrl) {
          setKiinteistot(prev =>
            prev.map(item =>
              item.id_kiinteisto === kiinteisto.id_kiinteisto
                ? { ...item, coverImageUrl }
                : item
            )
          );
        }
      });

    } catch (error) {
      if (error.response) {
        switch (error.response.status) {
          case 403: setErrMessage('Käyttäjä ei ole kirjautunut sisään tai oikeudet puuttuvat (403)'); break;
          case 401: setErrMessage('Autentikointi epäonnistui (401)'); break;
          case 500: setErrMessage('Palvelinvirhe (500)'); break;
          default: setErrMessage(`Virhe haussa: ${error.response.status}`);
        }
      } else {
        setErrMessage(error.message || 'Tuntematon virhe haussa');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => { setPage(1); fetchData(); };
  const handleKeyDown = (e) => { if (e.key === 'Enter') handleSearch(); };

  const openKohoModal = async () => {
    setShowModal(true);
    setKohoOffers([]);
    setKohoError('');
    setKohoSelected(new Set());
    setKohoImportResults(null);
    setKohoLoading(true);
    try {
      const res = await getKohoAllOffers();
      const offers = res.data?.offers ?? res.data ?? [];
      const withAddress = offers.filter(o =>
        o.customer && (o.customer.delivery_address || o.customer.address)
      );
      setKohoOffers(withAddress);
    } catch (e) {
      setKohoError('KOHO-haku epäonnistui: ' + (e.message ?? e));
    } finally {
      setKohoLoading(false);
    }
  };

  const toggleKohoSelect = (id) => {
    setKohoSelected(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const importSelected = async () => {
    setKohoImporting(true);
    const toImport = kohoOffers.filter(o => kohoSelected.has(o.id));
    const results = [];
    for (const offer of toImport) {
      const c = offer.customer;
      const osoite = c.delivery_address || c.address || '';
      const postinumero = c.delivery_zip_code || c.zip_code || '';
      const toimipaikka = c.delivery_city || c.city || '';
      try {
        await createEmptyTaloyhtio({
          kohteen_nimi: c.name || offer.name || '',
          rakennukset: osoite ? [{ osoite, postinumero, toimipaikka }] : [],
        });
        results.push({ offer, ok: true });
      } catch (e) {
        results.push({ offer, ok: false, error: e.message });
      }
    }
    setKohoImportResults(results);
    setKohoImporting(false);
    if (results.some(r => r.ok)) fetchData();
  };

  useEffect(() => { fetchData(); }, [page, pageSize, resultOrder]);
  useEffect(() => { setRecentVisits(getRecentVisits()); }, []);

  return (
    <div className="main-content">
      <div className="bg-success text-white d-flex align-items-center justify-content-center shadow-sm" style={{ minHeight: '20vh' }}>
        <header className="w-100 px-3 mt-3 text-center">
        
          <h1 className="fw-bold fs-4 display-5 mb-3">Hae taloyhtiökortteja</h1>

          <div className="mx-auto" style={{ maxWidth: '600px' }}>
            
            <InputGroup className="mb-3 shadow-sm rounded w-100">
              <Form.Control
                type="text"
                placeholder="Kiinteistötunnus, osoite, paikkakunta tai kohteen nimi"
                aria-label="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleKeyDown}
                className="border-primary flex-grow-1 text-center"
              />
              <Button variant="success" onClick={handleSearch}>Hae</Button>
            </InputGroup>

            <div className="d-flex justify-content-center gap-2 mb-3">
              <Dropdown drop="down">
                <Dropdown.Toggle variant="light" size="sm">{resultOrder === 'DESC' ? 'Uusimmat' : 'Vanhimmat'}</Dropdown.Toggle>
                <Dropdown.Menu className="text-center border">
                  <Dropdown.Item className="py-1 px-2 border-bottom" onClick={() => setResultOrder('DESC')}>Uusimmat</Dropdown.Item>
                  <Dropdown.Item className="py-1 px-2" onClick={() => setResultOrder('ASC')}>Vanhimmat</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              {false && (
                <Button variant="outline-light" size="sm" onClick={openKohoModal}>
                  Tuo KOHOsta
                </Button>
              )}
            </div>
          </div>
        </header>
      </div>

      <div className='container'>
        <div className="text-center my-3 fw-semibold">Kortteja: {totalItems} | Sivuja: {totalPages}</div>

        {recentVisits.length > 0 && (
          <div className="mb-4">
            <div className="text-muted small fw-semibold mb-2" style={{ letterSpacing: '0.05em' }}>VIIMEKSI AVATUT</div>
            <div className="row g-2">
              {recentVisits.map(v => <RecentCard key={v.id_kiinteisto} visit={v} />)}
            </div>
          </div>
        )}

       <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" scrollable>
          <Modal.Header closeButton>
            <Modal.Title>Tuo kortit KOHO-tarjouksista</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {kohoError && <div className="alert alert-danger py-2">{kohoError}</div>}
            {kohoLoading && <div className="text-center py-4"><div className="spinner-border text-success" /></div>}

            {kohoImportResults ? (
              <div>
                <div className="fw-semibold mb-2">Tuonti valmis</div>
                {kohoImportResults.map(({ offer, ok, error }) => (
                  <div key={offer.id} className={`d-flex align-items-center gap-2 mb-1 small ${ok ? 'text-success' : 'text-danger'}`}>
                    <span>{ok ? '✓' : '✗'}</span>
                    <span>{offer.customer?.name || offer.name}</span>
                    {error && <span className="text-muted">— {error}</span>}
                  </div>
                ))}
              </div>
            ) : (
              <>
                {!kohoLoading && kohoOffers.length === 0 && !kohoError && (
                  <p className="text-muted">Ei tarjouksia osoitetiedoilla.</p>
                )}
                {kohoOffers.length > 0 && (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="small text-muted">{kohoOffers.length} tarjousta osoitetiedoilla</span>
                      <div className="d-flex gap-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={() => setKohoSelected(new Set(kohoOffers.map(o => o.id)))}>Valitse kaikki</button>
                        <button className="btn btn-sm btn-outline-secondary" onClick={() => setKohoSelected(new Set())}>Tyhjennä</button>
                      </div>
                    </div>
                    <div style={{ overflowX: 'auto' }}>
                      <table className="table table-sm table-hover">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: 36 }}></th>
                            <th>Tarjous</th>
                            <th>Asiakas</th>
                            <th>Y-tunnus</th>
                            <th>Toimitusosoite</th>
                            <th>Postinumero</th>
                            <th>Kaupunki</th>
                          </tr>
                        </thead>
                        <tbody>
                          {kohoOffers.map(o => {
                            const c = o.customer;
                            return (
                              <tr key={o.id} onClick={() => toggleKohoSelect(o.id)} style={{ cursor: 'pointer' }}>
                                <td>
                                  <input type="checkbox" checked={kohoSelected.has(o.id)} onChange={() => toggleKohoSelect(o.id)} onClick={e => e.stopPropagation()} />
                                </td>
                                <td className="small">{o.name || `#${o.id}`}</td>
                                <td className="small fw-semibold">{c.name}</td>
                                <td className="small text-muted">{c.organization_id || '—'}</td>
                                <td className="small">{c.delivery_address || c.address || '—'}</td>
                                <td className="small">{c.delivery_zip_code || c.zip_code || '—'}</td>
                                <td className="small">{c.delivery_city || c.city || '—'}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Sulje</Button>
            {!kohoImportResults && (
              <Button
                variant="success"
                onClick={importSelected}
                disabled={kohoImporting || kohoSelected.size === 0}
              >
                {kohoImporting
                  ? <><span className="spinner-border spinner-border-sm me-1" />Luodaan...</>
                  : `Luo ${kohoSelected.size} korttia`}
              </Button>
            )}
          </Modal.Footer>
        </Modal>
            
        <nav aria-label="Page navigation" className="d-flex justify-content-center my-3">
          <ul className="pagination shadow-sm rounded">
            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
              <button className="page-link text-success" onClick={decreasePage}>Edellinen</button>
            </li>
            <li className="page-item disabled">
              <span className="page-link">{page} / {totalPages}</span>
            </li>
            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
              <button className="page-link text-success" onClick={increasePage}>Seuraava</button>
            </li>
          </ul>
        </nav>

        {errMessage && <div className="text-center mb-3"><Badge bg="danger" pill>{errMessage}</Badge></div>}
        {loading && <div className="text-center my-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Ladataan...</span></div></div>}

        <div className="row g-4">
          {kiinteistot.map((kiinteisto) => (
            <div key={kiinteisto.id_kiinteisto} className="col-md-6 col-lg-4 mb-1">
              <Card className="h-100 border-0 rounded-4 card-hover" style={{ boxShadow: '0 12px 24px rgba(0, 0, 0, 0.2)' }}>
                <Card.Header
                  className="text-white text-center px-3 py-4 rounded-top"
                  style={{
                    position: 'relative',
                    backgroundColor: kiinteisto.coverImageUrl ? 'transparent' : '#04aa00', // success color if no image
                    backgroundImage: kiinteisto.coverImageUrl ? `url(${kiinteisto.coverImageUrl})` : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: 180,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderTopLeftRadius: '1rem',
                    borderTopRightRadius: '1rem',
                  }}
                >
                {kiinteisto.coverImageUrl ? (
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundColor: 'rgba(0,0,0,0.4)', // dark overlay for text readability
                      borderTopLeftRadius: '1rem',
                      borderTopRightRadius: '1rem',
                    }}
                  />
                ) : (
                  <BsBuildingFill size={80} style={{ zIndex: 1 }} className="mb-2" />
                )}

                <div style={{ position: 'relative', zIndex: 2 }}>
                  <div className="fw-semibold fs-5 text-truncate">
                    {kiinteisto.rakennukset_fulls[0]?.osoite}
                  </div>

                  <div className="mb-2 text-muted small" style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)', padding: '2px 4px', borderRadius: 3 }}>
                    {kiinteisto.kohteen_nimi && (
                      <div>
                        Kohteen nimi: <span className="text-dark">{kiinteisto.kohteen_nimi}</span>
                      </div>
                    )}
                    {kiinteisto.tontin_omistaja && (
                      <div>
                        Tontin omistaja: <span className="text-dark">{kiinteisto.tontin_omistaja}</span>
                      </div>
                    )}
                  </div>

                  <div className="small text-truncate opacity-75">
                    {kiinteisto.rakennukset_fulls[0]?.postinumero} {kiinteisto.rakennukset_fulls[0]?.toimipaikka}
                  </div>
                </div>
              </Card.Header>

                <Card.Body className="d-flex flex-column justify-content-between p-3 text-center">
                  <div className="mb-2 text-muted small">Kiinteistötunnus: <span className="text-dark">{kiinteisto.kiinteistotunnus}</span></div>
                  <Link to={`/taloyhtiokortti/${kiinteisto.id_kiinteisto}`} className="mt-auto">
                    <Button variant="success" className="w-100 fw-semibold rounded-pill">Avaa kortti</Button>
                  </Link>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>

        <nav aria-label="Page navigation" className="d-flex justify-content-center my-3">
          <ul className="pagination shadow-sm rounded">
            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
              <button className="page-link text-success" onClick={decreasePage}>Edellinen</button>
            </li>
            <li className="page-item disabled">
              <span className="page-link">{page} / {totalPages}</span>
            </li>
            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
              <button className="page-link text-success" onClick={increasePage}>Seuraava</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default Taloyhtiokortit;
